import styled from 'styled-components';

const TermsAndConditionsTemplateStyle = styled.section`
	--largeDistance: var(--sp6x);
	--mediumDistance: var(--sp5x);
	--smallDistance: var(--sp4x);
	--xSmallDistance: var(--sp3x);

	margin-top: var(--pageDistance);

	.subtitle {
		margin-top: var(--mediumDistance);
	}

	.overview-title {
		margin-top: var(--largeDistance);
	}

	.overview-description {
		margin-top: var(--smallDistance);
	}

	.descriptions-wrapper {
		display: flex;
		flex-direction: column;
		gap: var(--largeDistance);
		margin-top: var(--largeDistance);
	}

	.editor-wrapper {
		margin-top: var(--xSmallDistance);

		* {
			color: var(--black850);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--largeDistance: var(--sp4x);
		--mediumDistance: var(--sp5x);
		--smallDistance: var(--sp4x);
		--xSmallDistance: var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--largeDistance: var(--sp3x);
		--mediumDistance: var(--sp4x);
		--smallDistance: var(--sp4x);
		--xSmallDistance: var(--sp3x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--largeDistance: var(--sp3x);
		--mediumDistance: var(--sp4x);
		--smallDistance: var(--sp4x);
		--xSmallDistance: var(--sp3x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--largeDistance: var(--sp3x);
		--mediumDistance: var(--sp4x);
		--smallDistance: var(--sp3x);
		--xSmallDistance: var(--sp2-5x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--largeDistance: var(--sp2-5x);
		--mediumDistance: var(--sp4x);
		--smallDistance: var(--sp2-5x);
		--xSmallDistance: var(--sp2-5x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--largeDistance: var(--sp2-5x);
		--mediumDistance: var(--sp4x);
		--smallDistance: var(--sp2-5x);
		--xSmallDistance: var(--sp2-5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--largeDistance: var(--sp2-5x);
		--mediumDistance: var(--sp4x);
		--smallDistance: var(--sp2-5x);
		--xSmallDistance: var(--sp2x);
	}
`;

export default TermsAndConditionsTemplateStyle;
